import { webSourceEscortSiteOptions, webSourceFieldLabels, webSourceFieldPlaceholders } from './webSourceFields';

export function readableFormat(fieldName) {
  if (!fieldName) {
    return fieldName;
  }

  return (
    fieldName
      .split(/(?=[A-Z])/)
      .join(' ')
      // capitalize first letter of first word
      .replace(/\w\S*/g, word => word.charAt(0).toUpperCase() + word.substr(1))
  );
}

export const webSourceFieldLabel = (field, source, hideDetails = false) => {
  const label = webSourceFieldLabels[`${source}_${field}`] || webSourceFieldLabels[field] || readableFormat(field);
  if (hideDetails) {
    // If hide details is true, remove the details from the label. Remove anything between [].
    return label.replace(/\s\[.*\]/, '');
  } else {
    return label;
  }
};
export const webSourceFieldPlaceholder = field => webSourceFieldPlaceholders[field] || readableFormat(field);

export const fieldValue = (uniqueFieldKey, keyValue) => {
  if (!uniqueFieldKey) {
    return keyValue;
  }

  if (uniqueFieldKey === 'escortSiteTitle') {
    const escortSiteOption = webSourceEscortSiteOptions.find(({ value }) => value === keyValue);

    if (escortSiteOption) {
      return escortSiteOption.label;
    }
  }

  if (keyValue && ['adDate', 'dateOfBirth', 'date'].includes(uniqueFieldKey)) {
    // const date = new Date(keyValue);
    // let date = new Date();
    const date = fromCalendarDate(keyValue);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // hour12: true, // Use 12-hour format
    };
    // Test to see if keyValue is a date string with timezone and create a new object based on that
    // const datePartsZone = keyValue.split('T');

    // // If the time zone is included in the date string, we need to create a new date object based on the time zone
    // // otherwise initialize the date object for the current user and set the values using the old method.
    // if (datePartsZone.length < 2) {
    //   const dateParts = datePartsZone[0].split('-');
    //   date.setFullYear(dateParts[0]);
    //   date.setMonth(dateParts[1] - 1);
    //   date.setDate(dateParts[2]);
    // } else {
    //   date = new Date(keyValue);
    // }
    // date.setFullYear(dateParts[0]);
    // date.setMonth(dateParts[1] - 1);
    // date.setDate(dateParts[2]);
    console.log({ date, keyValue });

    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    return formattedDate;
    // return new Date(keyValue).toLocaleDateString();
  }

  // Default
  return keyValue;
};

export const usesOldEscortAdFormat = record => {
  const { escortAd } = record;

  if (!escortAd) {
    return false;
  }
  const escortAdData = [escortAd.url, ...escortAd.phones.map(({ phone }) => phone), escortAd.description];
  const escortAdEmpty = escortAdData.filter(Boolean).length === 0;

  // console.log({ escortAdEmpty, escortAdData });

  // If all fields are empty, it's the old format
  return !escortAdEmpty;
};

export const sortWebSourceFields = order => {
  // if (!order) {
  //   return fields;
  // }

  return ([a], [b]) => {
    const aIndex = order.indexOf(a);
    const bIndex = order.indexOf(b);

    if (aIndex === -1) {
      return 1;
    }

    if (bIndex === -1) {
      return -1;
    }

    return aIndex - bIndex;
  };
};
/**
 * Converts a Date object to a pure calendar date in the format YYYY-MM-DD.
 * @param {Date} date - The Date object to convert.
 * @returns {string} - The calendar date in YYYY-MM-DD format.
 */
export const toCalendarDate = date => {
  if (!(date instanceof Date)) {
    throw new Error('Invalid input: Expected a Date object.');
  }

  // const year = date.getUTCFullYear(); // Get the year in UTC
  const year = date.getFullYear(); // Get the year in local time
  // const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based, pad to 2 digits
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, pad to 2 digits
  // const day = String(date.getUTCDate()).padStart(2, '0'); // Pad the day to 2 digits
  const day = String(date.getDate()).padStart(2, '0'); // Pad the day to 2 digits

  return `${year}-${month}-${day}`; // Return the date in YYYY-MM-DD format
};
/**
 * Converts a pure calendar date string (YYYY-MM-DD) or an ISO string (from date.toISOString())
 * into a Date object.
 * @param {string} dateString - The calendar date string in YYYY-MM-DD format or an ISO string.
 * @returns {Date} - A Date object representing the calendar date in Local time.
 */
export const fromCalendarDate = dateString => {
  if (!dateString || typeof dateString !== 'string') {
    throw new Error('Invalid input: Expected a string.');
  }

  // Check if the input is in YYYY-MM-DD or YYYY-M-D format
  if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(dateString)) {
    // Split the date string into components
    const [year, month, day] = dateString.split('-').map(Number);

    // Create a Date object in UTC (month is 0-based, so subtract 1)
    // const date = new Date(Date.UTC(year, month - 1, day));
    // // Create a Date object in local time
    const date = new Date(dateString);
    // const date = new Date();
    // // Set date zone to UTC
    // date.setZone('UTC');


    // date.setUTCFullYear(year);
    // date.setUTCMonth(month - 1);
    // date.setUTCDate(day);

    date.setFullYear(year);
    date.setDate(day);
    date.setMonth(month - 1);
    // date.setMonth(month);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    console.log('Calendar Date', { date, dateString });
    return date;
  }

  // Check if the input is an ISO string (e.g., 2025-04-10T00:00:00.000Z)
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(dateString)) {
    // Create a Date object directly from the ISO string
    return new Date(dateString);
  }

  // If the input doesn't match either format, throw an error
  throw new Error('Invalid input: Expected a date string in YYYY-MM-DD or ISO format.');
};
